<template>
    <dl class="m-list-definition" :class="{'m-list-definition_decimal' : decimal }">
        <slot></slot>
    </dl>
</template>
<script>
    export default {
        name: "ListDefinition",
        props: {
            /**
             * 先頭マーカーを1., 2.にするか
             */
            decimal: {
                type: Boolean,
                require: false,
                default: false
            }
        }
    }
</script>
